import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent } from "vue";
//@ts-ignore
import BaseBtModal from "@vueEntry/BaseBtModal.vue";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import BaseAlert from "@vueEntry/UIKitComponents/BaseAlert.vue";
import { getDefaultSearchBean } from "@wikicasa/common/model/RealEstateSearchBean";
import { COLORS, MAP_TILER_APIKEY } from "../../components/variables";
import LeafletMap from "@wkWebSrc/js/LeafletMap/leaflet_map";
import { LatLng } from "leaflet";
import { validateMap, parsePoints, getPolygonString } from "@utils/MapUtils";
import { ENERGY_CLASS } from "@customTypes/EnergyClass";
import { BREAKPOINT } from "@customTypes/BreakpointEnum";
import { mapState, mapActions } from "pinia";
import { useBreakpoints } from "@wkComposables/useBreakpoints";
import { useSearch } from "@wkComposables/useSearch";
import { getPlace } from "@services/placesAPI";
//@ts-ignore
import BaseAutocomplete from "@vueEntry/UIKitComponents/BaseAutocomplete.vue";
import { getPlacesAddressAutocomplete, getPlacesDetails, getAroundMePolygon } from "@services/geographyAPI";
import { GAutocompleteTypes } from "@customTypes/GAutocompleteTypes";
import { googlePlaceConverter } from "@utils/GAutocompleteUtils";
import { PLACE_TYPE } from "@customTypes/PlaceType";
import { getUserPosition, browserSupportGeolocation } from "@utils/GeolocationUtils";
import { useSearchBeanStore } from "@store/SearchBeanStore";
var USER_POSITION_ZOOM = 17;
var AROUNDME_POSITION_ZOOM = 13;
var DESKTOP_POSITION_ZOOM = 7;
var DEFAULT_POSITION = {
  lat: 41.902782,
  lng: 12.496366,
  zoom: 6
};
export default defineComponent({
  name: "MapModal",
  components: {
    BaseBtModal,
    BaseButton,
    BaseAlert,
    BaseAutocomplete
  },
  props: {
    showMapModal: {
      type: Boolean,
      default: false
    },
    listing: {
      type: Boolean
    },
    aroundMe: {
      type: Boolean,
      default: false
    },
    previouslyAroundMe: {
      type: Boolean
    },
    place: {
      type: Object
    }
  },
  emits: ["emit-place", "hide-map-modal"],
  setup() {
    var {
      isDesktopMode,
      isLarge,
      isSmall
    } = useBreakpoints();
    var {
      search
    } = useSearch();
    return {
      isDesktopMode,
      isLarge,
      isSmall,
      //useSearch
      search
    };
  },
  data() {
    return {
      searchBeanModal: getDefaultSearchBean(),
      mapDrawing: false,
      hasPolygon: false,
      center: DEFAULT_POSITION,
      mapPlace: null,
      map: null,
      idUserPositionMarker: 0,
      mapPositionMarker: 1,
      loadingAroundMePolygon: false,
      currentRadius: 0,
      //meters
      currentMapIDbase: "draw-on-mobile_",
      currentMapID: "draw-on-mobile_" + Date.now(),
      // userLocationError = false,
      mapError: false,
      mapWarning: false,
      labelText: "",
      loading: false,
      isPlace: false,
      openMapModal: false,
      pmCustomEvent: null,
      currentAddress: undefined,
      autocompleteDisabled: true
    };
  },
  computed: Object.assign({
    cdn() {
      return window["_cdn"];
    },
    headerClasses() {
      //@ts-ignore
      return this.isDesktopMode ? "tw-hidden" : "tw-pb-10px tw-pt-15px";
    },
    labels() {
      return window["_labels"];
    },
    currentRadiusKm() {
      if (!this.currentRadius) return 0;
      return this.currentRadius / 1000;
    },
    isDesktop() {
      return window.screen.width > BREAKPOINT.SMALL;
    }
  }, mapState(useSearchBeanStore, ["searchBean"])),
  watch: {
    hasPolygon(cur, prev) {
      this.checkMapError();
    },
    mapPlace(cur, prev) {
      var _a, _b, _c;
      (_a = this.map) === null || _a === void 0 ? void 0 : _a.startSpinner();
      (_b = this.map) === null || _b === void 0 ? void 0 : _b.setCenter(cur.latitude, cur.longitude, USER_POSITION_ZOOM);
      (_c = this.map) === null || _c === void 0 ? void 0 : _c.stopSpinner();
    },
    currentRadius(cur, prev) {
      this.updateAroundMePolygon();
    }
  },
  created() {
    this.openMapModal = this.showMapModal;
  },
  mounted() {
    this.mapWarning = false;
    this.searchBeanModal = JSON.parse(JSON.stringify(this.searchBean));
    this.searchBeanModal.listingTypologyURL = window._listingTypologyURL;
    this.idUserPositionMarker = Date.now();
    this.convertEnergyClassFilter();
    this.convertFloor();
    this.onOpened();
  },
  methods: Object.assign({
    browserSupportGeolocation,
    onInputChangeCb(query) {
      return __awaiter(this, void 0, void 0, function* () {
        var res = yield getPlacesAddressAutocomplete(query, 10, [GAutocompleteTypes.DRAWONMAP]);
        return res.map(r => ({
          label: r.description,
          id: r.place_id
        }));
      });
    },
    optionSelectedCb(selectedEl) {
      var _a;
      return __awaiter(this, void 0, void 0, function* () {
        if (!selectedEl) {
          this.isPlace = false;
          return;
        }
        //Removing the polygon iff there is a map error (e.g. area too large )
        !this.mapWarning && this.deletePolygon();
        var gPlaceDetails = yield getPlacesDetails("".concat(selectedEl === null || selectedEl === void 0 ? void 0 : selectedEl.id));
        var curPlace = yield googlePlaceConverter(gPlaceDetails, selectedEl.label);
        this.autocompleteDisabled = true;
        var _currentAddress = "";
        try {
          if (curPlace.placeType == PLACE_TYPE.CITY && curPlace.streetName) {
            _currentAddress = "".concat(curPlace.streetName);
            if (curPlace.streetNumber) {
              _currentAddress += " ".concat(curPlace.streetNumber);
            }
            if (curPlace.zip) {
              _currentAddress += " ".concat(curPlace.zip);
            }
            _currentAddress += "".concat(curPlace.displayName).trim();
          } else _currentAddress = "".concat(curPlace.displayName).trim();
          this.currentAddress = {
            label: _currentAddress
          };
        } catch (e) {
          this.currentAddress = {
            label: "".concat(curPlace.displayName).trim()
          };
        }
        this.mapPlace = curPlace;
        this.isPlace = true;
        this.setCoordinates(this.mapPlace.latitude, this.mapPlace.longitude, USER_POSITION_ZOOM);
        this.updateMapCenter();
        (_a = this.map) === null || _a === void 0 ? void 0 : _a.addMarker(this.idUserPositionMarker, new LatLng(this.mapPlace.latitude, this.mapPlace.longitude));
      });
    },
    deletePolygonAndCloseModal() {
      this.deletePolygon();
      this.closeMapModal();
    },
    onOpened() {
      this.initMap();
      if (this.aroundMe) return;
    },
    convertEnergyClassFilter() {
      //@ts-ignore
      switch (this.searchBean.energyClassFilter) {
        case "HIGH":
          {
            this.searchBeanModal.energyClassFilter = ENERGY_CLASS.HIGH;
            break;
          }
        case "MEDIUM":
          {
            this.searchBeanModal.energyClassFilter = ENERGY_CLASS.MEDIUM;
            break;
          }
        case "LOW":
          {
            this.searchBeanModal.energyClassFilter = ENERGY_CLASS.LOW;
            break;
          }
      }
    },
    convertFloor() {
      this.searchBeanModal.floor = this.searchBeanModal.floorId;
    },
    checkMapError() {
      this.mapError = this.map ? !validateMap(this.map) : true;
      this.labelText = !this.aroundMe ? this.labels.mapTooLarge : this.labelText;
    },
    getPlaceFn(query) {
      return getPlace(query);
    },
    setCoordinates(latitude, longitude, zoom) {
      this.center.lat = latitude;
      this.center.lng = longitude;
      this.center.zoom = zoom;
    },
    loadingMapAroundMe() {
      var _a, _b, _c, _d, _e;
      return __awaiter(this, void 0, void 0, function* () {
        (_a = this.map) === null || _a === void 0 ? void 0 : _a.startSpinner();
        if (!this.currentRadius) this.currentRadius = 1000;
        try {
          var positionCb = getUserPosition();
          if (!positionCb) throw new Error("Localitation not available");
          var position = yield positionCb;
          this.mapWarning = false;
          (_b = this.map) === null || _b === void 0 ? void 0 : _b.stopSpinner();
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.setCoordinates(pos.lat, pos.lng, AROUNDME_POSITION_ZOOM);
          this.updateMapCenter();
          //controllare se effettivamente serve
          if (!this.aroundMe) (_c = this.map) === null || _c === void 0 ? void 0 : _c.addMarker(this.idUserPositionMarker, pos);
          yield this.updateAroundMePolygon();
        } catch (error) {
          console.error("user position errore", error);
          //1 is permission denied
          if (error.code == 1) {
            this.labelText = this.labels.positionNotAllowed;
          }
          // every other errors
          else {
            this.labelText = this.labels.errorTryAgain;
          }
          this.mapWarning = true;
          (_d = this.map) === null || _d === void 0 ? void 0 : _d.removeMarker(this.idUserPositionMarker);
          this.center.zoom = AROUNDME_POSITION_ZOOM;
          yield this.updateAroundMePolygon();
          (_e = this.map) === null || _e === void 0 ? void 0 : _e.stopSpinner();
        }
      });
    },
    updateAroundMePolygon() {
      return __awaiter(this, void 0, void 0, function* () {
        this.loadingAroundMePolygon = true;
        var response = yield getAroundMePolygon(this.center.lat, this.center.lng, this.currentRadius);
        try {
          if (!response.data) return;
          this.searchBeanModal.polygonFromMap = response.data;
          this.drawPolygon(response.data);
        } catch (error) {
          console.error(error);
        } finally {
          this.loadingAroundMePolygon = false;
        }
      });
    },
    getPosition() {
      var _a, _b;
      (_a = this.map) === null || _a === void 0 ? void 0 : _a.startSpinner();
      (_b = getUserPosition()) === null || _b === void 0 ? void 0 : _b.then(position => {
        var _a, _b, _c;
        (_a = this.map) === null || _a === void 0 ? void 0 : _a.stopSpinner();
        this.mapWarning = false;
        this.deletePolygon();
        var pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.setCoordinates(pos.lat, pos.lng, USER_POSITION_ZOOM);
        this.updateMapCenter();
        (_b = this.map) === null || _b === void 0 ? void 0 : _b.addMarker(this.idUserPositionMarker, pos);
        (_c = this.map) === null || _c === void 0 ? void 0 : _c.stopSpinner();
      }, error => {
        var _a, _b;
        //map.setCenter(DEFAULT_POSITION.lat, DEFAULT_POSITION.lng, DEFAULT_POSITION.zoom);
        if (error.code == 1) {
          this.labelText = this.labels.positionNotAllowed;
        } else {
          this.labelText = this.labels.errorTryAgain;
        }
        this.mapWarning = true;
        (_a = this.map) === null || _a === void 0 ? void 0 : _a.removeMarker(this.idUserPositionMarker);
        (_b = this.map) === null || _b === void 0 ? void 0 : _b.stopSpinner();
      });
    },
    updateMapCenter() {
      var _a, _b;
      (_a = this.map) === null || _a === void 0 ? void 0 : _a.removeMarker(this.idUserPositionMarker);
      (_b = this.map) === null || _b === void 0 ? void 0 : _b.setCenter(this.center.lat, this.center.lng, this.center.zoom);
    },
    initMap() {
      var _a, _b;
      this.map = new LeafletMap();
      var map_selector = this.$refs.mapPlaceholder;
      (_a = this.map) === null || _a === void 0 ? void 0 : _a.init(map_selector, MAP_TILER_APIKEY, COLORS, {
        touch: !this.isLarge
      });
      (_b = this.map) === null || _b === void 0 ? void 0 : _b.ready(() => __awaiter(this, void 0, void 0, function* () {
        var _c, _d, _e;
        if (this.aroundMe) yield this.loadingMapAroundMe();else if (!this.listing && this.previouslyAroundMe) {
          this.searchBeanModal.polygonFromMap = "";
          this.searchBeanModal.polygonForDB = "";
          this.deletePolygon();
        } else if (this.searchBeanModal.polygonFromMap || this.searchBeanModal.polygonForDB) {
          this.hasPolygon = true;
          this.mapDrawing = true;
          this.searchBeanModal.polygonForDB ? this.drawPolygon(this.searchBeanModal.polygonForDB) : this.drawPolygon(this.searchBeanModal.polygonFromMap);
        } else {
          (_c = this.map) === null || _c === void 0 ? void 0 : _c.setCenter(this.center.lat, this.center.lng, window.screen.width > BREAKPOINT.SMALL ? DESKTOP_POSITION_ZOOM : this.center.zoom);
          this.hasPolygon = false;
          this.mapDrawing = false;
        }
        var isBgImageShown = true;
        var removeBgImage = () => {
          if (!isBgImageShown) return;
          map_selector.style.backgroundImage = "none";
          isBgImageShown = false;
        };
        (_d = this.map) === null || _d === void 0 ? void 0 : _d.on("zoomstart", removeBgImage);
        (_e = this.map) === null || _e === void 0 ? void 0 : _e.on("draw:created", () => {
          this.hasPolygon = true;
        });
      }));
    },
    drawPolygon(polygon) {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      var latLngs = parsePoints(polygon);
      if (latLngs) {
        if ((_a = this.map) === null || _a === void 0 ? void 0 : _a.getMap()) {
          (_b = this.map) === null || _b === void 0 ? void 0 : _b.deleteShape();
          (_d = (_c = this.map) === null || _c === void 0 ? void 0 : _c.getMap()) === null || _d === void 0 ? void 0 : _d.invalidateSize();
        }
        //@ts-ignore
        (_e = this.map) === null || _e === void 0 ? void 0 : _e.drawPolygonFromPoints(latLngs);
        (_f = this.map) === null || _f === void 0 ? void 0 : _f.fitBounds((_h = (_g = this.map) === null || _g === void 0 ? void 0 : _g.getShape()) === null || _h === void 0 ? void 0 : _h.getBounds());
      }
      this.checkMapError();
    },
    startDrawing() {
      var _a;
      this.mapError = false;
      this.mapWarning = false;
      this.hasPolygon = false;
      this.mapDrawing = true;
      (_a = this.map) === null || _a === void 0 ? void 0 : _a.setDrawing();
    },
    deletePolygon() {
      var _a, _b;
      this.hasPolygon = false;
      this.mapError = false;
      this.mapDrawing = false;
      this.searchBeanModal.polygonFromMap = "";
      this.searchBeanModal.polygonForDB = "";
      this.updateSearchBean({
        polygonFromMap: "",
        polygonForDB: ""
      });
      (_a = this.map) === null || _a === void 0 ? void 0 : _a.deleteShape();
      (_b = this.map) === null || _b === void 0 ? void 0 : _b.stopDrawing();
    },
    confirmPolygon() {
      var _a, _b;
      this.loading = true;
      this.checkMapError();
      if (this.mapError) {
        this.loading = false;
        return;
      }
      this.searchBeanModal.polygonForDB = getPolygonString((_a = this.map) === null || _a === void 0 ? void 0 : _a.getShapePoints());
      this.searchBeanModal.polygonFromMap = this.map ? (_b = this.map) === null || _b === void 0 ? void 0 : _b.getShapePoints().map(point => "".concat(point.lat, ",").concat(point.lng, ";")).join("") : "";
      if (this.listing) {
        this.updateSearchBean({
          polygonForDB: this.searchBeanModal.polygonForDB,
          polygonFromMap: this.searchBeanModal.polygonFromMap,
          areaOfInterestId: undefined,
          areaId: undefined,
          placeType: undefined,
          placeId: undefined,
          zoneId: undefined,
          zoneIdList: [],
          localityIdList: [],
          districtIdList: [],
          districtId: undefined,
          cityId: undefined,
          provinceId: undefined,
          regionId: undefined,
          cityDisplayName: undefined,
          cityURL: undefined,
          zoneURL: undefined,
          streetURL: undefined
        });
        // BRUTAL FIX: previene il fatto che passi dal listato agenzia ad un listato real estate nella ricerca su mappa
        this.search(true, window.page_type == "Listato agenzie" ? "agenzie-immobiliari" : "", window.page_type !== "Listato agenzie");
      } else {
        this.loading = false;
        this.hasPolygon = true;
        this.mapDrawing = false;
        this.emitPlace();
      }
    },
    confirmAndSearchPolygon() {
      this.loading = true;
      this.confirmPolygon();
      this.loading = false;
    },
    closeMapModal() {
      this.pmCustomEvent = {
        type: "hide-map-modal"
      };
      this.openMapModal = false;
    },
    hideMapModal() {
      if (!this.pmCustomEvent) this.pmCustomEvent = {
        type: "hide-map-modal"
      };
      this.pmCustomEvent && this.$emit(this.pmCustomEvent.type, this.pmCustomEvent.payload);
    },
    emitPlace() {
      this.pmCustomEvent = {
        type: "emit-place",
        payload: {
          aroundMe: this.aroundMe,
          radius: this.currentRadiusKm,
          polygon: this.searchBeanModal.polygonFromMap ? this.searchBeanModal.polygonFromMap : "",
          polygonForDB: this.searchBeanModal.polygonForDB ? this.searchBeanModal.polygonForDB : ""
        }
      };
      this.openMapModal = false;
    }
  }, mapActions(useSearchBeanStore, ["setSearchBean", "setSearchBeanByKey", "updateSearchBean"]))
});